import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  openTopicDialog,
  setTopicDialogState,
  openAddSubscriber,
} from './store/actions/topic-action'
import { withStyles } from '@material-ui/core/styles'
import { FormattedMessage, useIntl } from 'react-intl'
import * as R from 'ramda'
import { useTableFetch, pageToSortPairs } from 'commons/reactTableFetch'
import effects from 'app/effects/effects'
import LargeToolbar from 'app/components/LargeToolbar'
import ContentToolbarPage from 'app/components/ContentToolbarPage'
import { useIsOnline } from 'commons/useIsOnline'
import { PaidPlanAccess } from 'app/auth/paidPlanAccess'
import PaidPlanAccessFullScreen from 'app/auth/PaidPlanAccessFullScreen'
import NetworkError from 'app/components/NetworkError'
import { getTopicStatus } from './configs/constants'
import AccessControl from 'app/auth/AccessControl'
import { AccessType } from 'app/auth/accessControlService'
import { Routes } from 'app/services/routeService/routeService'
import { useAccessControl } from 'app/auth/useAccessControl'
import HeaderTopicCard from 'app/components/HeaderTopicCard'
import { renderRoutes } from 'react-router-config'
import { FuseSuspense } from '@fuse'
import { matchPath } from 'react-router'
import { Link as RouterLink } from 'react-router-dom'
import { Icon, Typography, Link } from '@material-ui/core'
import FabButton from 'app/components/buttons/FabButton'

const styles = (theme) => ({
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
  link: {
    color: `${theme.palette.secondary.main} !important`,
    textDecoration: 'none !important',
    '&:focus, &:hover, &:visited, &:link, &:active': {
      textDecoration: 'none !important',
    },
  },
})

const fetchData = (page) => {
  return effects.apis.getTopicList({
    page: page.currentPage,
    limit: page.pageSize,
    sort: pageToSortPairs(page),
    keyword: page.keyword,
    status: getTopicStatus(page.status),
    notificationCount: 1,
  })
}

const INITIAL_FILTER = { status: 'All' }

const TopicsPage = (props) => {
  const isShowDashboard = R.includes(process.env['REACT_APP_ENV'], [
    'dev',
    'qa',
    'prod',
  ])

  const match = matchPath(props.history.location.pathname, {
    path: '/topics/:topicsId',
  })

  const { formatMessage } = useIntl()

  const tableFetch = useTableFetch(fetchData, INITIAL_FILTER)
  const { pageInfo, refetchData, search } = tableFetch
  const isRootPage = R.isNil(match)

  let { isGranted } = useAccessControl([
    AccessType.NOTIFICATION_SEND,
    AccessType.ADMINISTRATION,
  ])

  useEffect(() => {
    handleViewTopicPage()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { route, history, classes } = props
  const [isOnline] = useIsOnline()

  const dispatch = useDispatch()

  const { dialogState } = useSelector((state) => state.topicReducer)

  function handleViewTopicPage() {
    if (isGranted) history.push(Routes.topics())
    else history.push(isShowDashboard && Routes.notificationTimeline()) // ? Routes.dashboard() : Routes.notificationTimeline()
  }

  const openDialogFromEmptyPage = () => {
    dispatch(setTopicDialogState(null))
    dispatch(openTopicDialog())
  }

  if (!isOnline) {
    return <NetworkError onRetryFetching={() => refetchData()} />
  }

  return (
    <AccessControl
      accesses={[AccessType.ADMINISTRATION, AccessType.NOTIFICATION_SEND]}
    >
      <PaidPlanAccess freePlanComponent={<PaidPlanAccessFullScreen />}>
        <ContentToolbarPage
          isFitViewPort={pageInfo.data?.length ? true : false}
          contentToolbar={
            <LargeToolbar
              content={
                <>
                  <Typography variant="h6">
                    <FormattedMessage id="notifications.topics.label" />
                  </Typography>
                  {!isRootPage && (
                    <>
                      <Link
                        to={Routes.topics()}
                        component={RouterLink}
                        className={classes.link}
                        color="primary"
                        onClick={() => refetchData()}
                      >
                        <div className="flex ltr:ml-5 rtl:mr-5 mt-2 cursor-pointer items-center">
                          <Icon className="text-base">arrow_back_ios</Icon>
                          <Typography className="ltr:pl-4 rtl:pr-4">
                            <FormattedMessage id="topics.goBackTo.home.page " />
                          </Typography>
                        </div>
                      </Link>
                    </>
                  )}
                </>
              }
              right={
                <>
                  {isRootPage && (
                    <>
                      <HeaderTopicCard
                        isNoTopicCard={pageInfo.isFirsttimeFetchingNoData}
                        search={search}
                        setIsOpenDialog={openDialogFromEmptyPage}
                        classes={classes}
                      />
                    </>
                  )}

                  {!isRootPage && R.prop('isActive', dialogState) ? (
                    <>
                      <FabButton
                        title={formatMessage({
                          id: 'topics.add.suscriber',
                        })}
                        aria-label="create group"
                        onClick={() => {
                          dispatch(openAddSubscriber())
                        }}
                      >
                        group_add
                      </FabButton>
                    </>
                  ) : null}
                </>
              }
            />
          }
          content={
            <FuseSuspense>
              {renderRoutes(route.routes, {
                tableFetch,
                refetchData,
              })}
            </FuseSuspense>
          }
        />
      </PaidPlanAccess>
    </AccessControl>
  )
}

export default withStyles(styles, { withTheme: true })(TopicsPage)
